import dynamicViews from './dynamic-views';
import schoolPicker from './school-picker';
import searchSelect from '../select-search';

const sponsorView = (() => {
  const self = {
    dom: {
      view: null
    },
    dynamicView: null,
    titleSeparator: ' - ' //separator between schoolname and rest of the title
  };

  function initCampaignSelector() {
    const campaignSelectorForm = document.querySelector('.js-walk-campaign-selector-form');

    if (!campaignSelectorForm) {
      return
    }

    const campaignSelector = campaignSelectorForm.querySelector('.js-walk-campaign-selector');
    self.campaignSelect = searchSelect.initSingle(campaignSelector);
    self.campaignSelect.on('change', () => {
      const selectedOptionHref = campaignSelector.options[campaignSelector.selectedIndex].dataset.href;
      const selectedOptionText = campaignSelector.options[campaignSelector.selectedIndex].text;
      if (selectedOptionHref) {
        campaignSelectorForm.setAttribute('action', selectedOptionHref);
        campaignSelectorForm.querySelector('button').removeAttribute('disabled');
        campaignSelectorForm.querySelector('.js-donation-target').innerHTML = selectedOptionText;
      } else {
        campaignSelectorForm.querySelector('button').setAttribute('disabled', true);
        campaignSelectorForm.querySelector('.js-donation-target').innerHTML = '';
      }
    });

  }

  function init() {
    self.dynamicView = dynamicViews.getView('walk-sponsor');

    if(!self.dynamicView) {
      return;
    }

    initCampaignSelector();

    schoolPicker.on('loading', (schoolId) => {
      self.dynamicView.replaceUrl(); // Use view base url
      self.dynamicView.showLoader();
      self.dynamicView.scrollToLoader({ behavior: 'smooth', block: 'center'});
    });

    schoolPicker.on('complete', (schoolId, data) => {
      if(data) {
        self.dynamicView.replaceUrl(schoolId);
        if(data?.school?.name) {
          self.dynamicView.replaceTitle(data.school.name, self.titleSeparator);
        }
        self.dynamicView.render(data);
        initCampaignSelector();
      }
    });
  }

  return {
    init
  }
})();

export default sponsorView;
export { sponsorView };
